<template>
  <div style="margin:0 auto;background-color: #F8F8F8">
    <div style="width:100%; position: fixed;top:0px;z-index: 10;">
      <div class="floatBtn">
        <div class="service" >
          <div class="serviceTextDiv" :class="{active: serviceMouseOn}" @mouseleave="serviceMouseleave" style="padding-left: 10px">
            <div style="cursor: pointer;font-weight: bold;text-decoration:underline;  font-size: 15px; color: #FFFFFF; text-align: left; margin-top: 10px;" @click="openQQ('1')">
              <img src="~@/assets/sendqq.png" width="25" height="25">
              招标代理
            </div>
            <div style="cursor: pointer;font-weight: bold;text-decoration:underline;  font-size: 15px; color: #FFFFFF; text-align: left; margin-top: 5px;" @click="openQQ('2')">
              <img src="~@/assets/sendqq.png" width="25" height="25">
              投标企业1群
            </div>
            <div style="cursor: pointer;font-weight: bold;text-decoration:underline;  font-size: 15px; color: #FFFFFF; text-align: left; margin-top: 5px;" @click="openQQ('3')">
              <img src="~@/assets/sendqq.png" width="25" height="25">
              投标企业2群
            </div>
            <div style="cursor: pointer;font-weight: bold;text-decoration:underline;  font-size: 15px; color: #FFFFFF; text-align: left; margin-top: 5px;" @click="openQQ('4')">
              <img src="~@/assets/sendqq.png" width="25" height="25">
              投标企业3群
            </div>
          </div>
          <h3 style="cursor: pointer" @mouseenter="serviceMouseenter"  ></h3>
  <!--        <a href="javascript:;"></a>-->
  <!--        <h3 id = "506434083" style="cursor: pointer"></h3>-->
        </div>

        <div class="hotline">
          <div class="hotlineTextDiv" :class="{active: mouseOn}">
              <div style="font-weight: bold; font-size: 15px; color: #FFFFFF; text-align: center; margin-top: 5px;">0591-87585006</div>
              <div style="font-size: 14px; color: #FFFFFF">周一至周五<br/>09:00 - 17:30</div>
          </div>
          <h3 style="cursor: pointer" @mouseenter="hotlineMouseenter" @mouseleave="hotlineMouseleave"></h3>
        </div>

<!--        <div class="signature" >
          <a style="cursor: pointer" href="/signatureCard.html" target="_blank"></a>
        </div>-->
        <div class="operamanual"  @click="openOpera()" >
          <a style="cursor: pointer" href="javascript:;" ></a>
        </div>
      </div>
<!--     <div class="signature" @mouseenter="signMouseenter" @mouseleave="signMouseleave">-->
<!--        <div class="hotlineTextDiv" :class="{active: signOn}">-->
<!--          <div style='margin-top: 10px;'>-->
<!--            <img src='~@/assets/portal/arrow.png' width='18px'>-->
<!--            <span style='display: inline-block;width: 80px'>-->
<!--              <a class='sign_font' style="cursor: pointer" href="/signatureCard.html" target="_blank">平台签章</a>-->
<!--            </span>-->
<!--          </div>-->
<!--          <div style='margin-top: 10px;'>-->
<!--            <img src='~@/assets/portal/arrow.png' width='18px'>-->
<!--            <span style='display: inline-block;width: 80px'>-->
<!--              <a class='sign_font' style="cursor: pointer" href="https://ggzyfw.fujian.gov.cn/CA/index/" target="_blank" >统一CA</a>-->
<!--            </span>-->
<!--          </div>-->
<!--        </div>-->
<!--        <h3 style="cursor: pointer"></h3>-->
<!--      </div>-->

      <div class="home-top">
        <div style="width: 1200px;height: 100px;margin:0 auto;">
          <div>
             <img src="~@/assets/logo1.png" style="float:left;margin-top: 20px;" width="60px;">
             <span style="line-height:96px;text-align:center;color:#4e4e4e;font-size: 30px;font-family: Microsoft YaHei;">福州市电子招投标交易系统</span>
             <div style="float:right;margin-top: 33px;">
              <div style="float:left;">
                <a-input-group compact>
                  <!--<a-select size="large" default-value="选项" style="width: 110px;">
                    <a-select-option value="新闻动态">
                      新闻动态
                    </a-select-option>
                    <a-select-option value="政策法规">
                      政策法规
                    </a-select-option>
                  </a-select>-->
                  <a-input-search placeholder="请输入搜索内容" style="width: 300px;background: #FFFFFF;font-family: Microsoft YaHei;font-weight: 400;color: #999999;" v-model="title"
                                  size="" @search="newsSearch" />
                </a-input-group>
              </div>
              <router-link :to="{path:'/user/login'}">
                <a-button type="primary" style="float:left;margin-left:20px;width: 80px;">
                  登录
                </a-button>
              </router-link>
              <router-link :to="{path:'/user/register'}">
                <!--<a href="http://www.fzztb.com/EbidEnterpriseWeb/TmEnterpriseRegister/regist.xhtml" target="_blank">-->
                 <a-button type="danger" style="float:left;margin-left:20px;width: 80px;">
                   注册
                 </a-button>
              </router-link>
<!--                </a>-->
             </div>
           </div>
         </div>
       </div>
       <div class="home-head" >
       <div class="home-menu" style="margin-top: -14px;">
         <ul>
           <router-link :to="{path:'/portal/home'}"><li :class="menuLevel==1 ? 'menuSelected' : 'menuNoSelected'">首页</li></router-link>
           <router-link :to="{path:'/portal/tender'}"><li :class="menuLevel==2 ? 'menuSelected' : 'menuNoSelected'">招标信息</li></router-link>
           <router-link :to="{path:'/portal/tenderService'}"><li :class="menuLevel==3 ? 'menuSelected' : 'menuNoSelected'">招投标服务</li></router-link>
           <router-link :to="{path:'/portal/news',query:{classifyCode: newsClassifyCode.news}}"><li :class="menuLevel==4 ? 'menuSelected' : 'menuNoSelected'">新闻动态</li></router-link>
           <router-link :to="{path:'/portal/news',query:{classifyCode: newsClassifyCode.poAndRe}}"><li :class="menuLevel==5 ? 'menuSelected' : 'menuNoSelected'">政策法规</li></router-link>
           <router-link :to="{path:'/portal/news',query:{classifyCode: 'A01A08'}}"><li :class="menuLevel==6 ? 'menuSelected' : 'menuNoSelected'">办事指南</li></router-link>
           <router-link :to="{path:'/portal/news',query:{classifyCode: 'A01A01'}}"><li :class="menuLevel==7 ? 'menuSelected' : 'menuNoSelected'">下载中心</li></router-link>
           <router-link :to="{path:'/portal/news',query:{classifyCode: newsClassifyCode.serviceCentre}}"><li :class="menuLevel==8 ? 'menuSelected' : 'menuNoSelected'">服务中心</li></router-link>
         </ul>
       </div>
     </div>
     </div>
     <div style="min-height: 140px;"></div>
     <router-view style="min-height:500px;"></router-view>
     <!--bottom -->
    <bottom-bar></bottom-bar>
  </div>
</template>

<script>
  import bottomBar from './Bottom'
  import {tenderProjectCategory,newsClassifyCode} from '@constant/portalConfig'

export default {
  name: "Home",
  components: {bottomBar},
  data() {
    return {
      newsClassifyCode:newsClassifyCode,
      title:"",
      menuLevel: 0,
      mouseOn: false,
      serviceMouseOn:false,
      signOn: false,
    }
  },
  created () {
    let routeUrl = this.$route;
    this.selectMenu(this.$route)
  },
  watch:{
    '$route' (to,from){
      this.selectMenu(to);
    }
  },
  methods: {
    selectMenu(route){
      if(route.path == "/portal/home") {
        this.menuLevel = 1;
      }
      if(route.path == "/portal/tender" || route.path == "/portal/tenderInfo"
        || route.path == "/portal/oldPlatform" || route.path == "/portal/oldPlatformInfo") {
        this.menuLevel = 2;
      }
      if (route.path == "/portal/tenderService") {
        this.menuLevel = 3;
      }
      if(route.path == "/portal/news") {
        let classifyCode = route.query.classifyCode;
        if(classifyCode!=null){
          if(classifyCode.indexOf("A01A03")>-1) this.menuLevel = 4;
          if(classifyCode.indexOf( "A01A04")>-1) this.menuLevel = 5;
          if(classifyCode.indexOf( "A01A08")>-1) this.menuLevel = 6;
          if(classifyCode.indexOf("A01A01")>-1) this.menuLevel = 7;
          if(classifyCode.indexOf("A01A02")>-1) this.menuLevel = 8;
        }
      }
    },
    newsSearch(){
      this.$router.push({ path: '/portal/newsSearch',query:{title: this.title} })
    },
    hotlineMouseenter() {
      this.mouseOn = true;
      this.serviceMouseOn=false;
    },
    hotlineMouseleave() {
      this.mouseOn = false;
    },
    serviceMouseenter() {
      this.serviceMouseOn = true;
    },
    serviceMouseleave() {
      this.serviceMouseOn = false;
    },
    signMouseenter() {
      this.signOn = true;
    },
    signMouseleave() {
      this.signOn = false;
    },
    openQQ(type)
    {
      let url=""
      if(type==="1")
      {
        window.open("http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=PpaUaolU_RCVZQOgmR8_Ogv6TRWtF-V7&authKey=kEL0%2B1rbAucqoPOKKJWmBbG9sk9p4RU%2BXPaUF3nFYedgee2fM2wsU26YsLw42QLQ&noverify=0&group_code=105393327")
      }else if(type==="2")
      {
        window.open("http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=u7elDLas21Qzd-Ff2j11zs3NVia6EQDQ&authKey=4nA6fhJxial6RGX%2F85%2B46EYrs%2B95SFIMhc1%2FTC3ixK2UY%2F0om539y%2B%2FLp3JA49FR&noverify=0&group_code=540062653")
      }
      else if(type==="3")
      {
        window.open("http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=xuk1dsmeXLJfkShiCTXSYnmW7z8ElJN9&authKey=PS09yk6UEJfkfdVb3YuI0FB3788qpYfbDprYTs6dserRDp1njYDC6SbBroVnc4%2Bb&noverify=0&group_code=632853381")
      }
      else if(type==="4")
      {
        window.open("http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=_Yjr94CXmMGlUk49AhHypnwA-11fNrbX&authKey=gxEmtp%2FNaV33upJDb3sSI5ynK1coA9vgZM21Kdl0tKXvSkh4w5hWCXnaFgoEXS6A&noverify=0&group_code=580013049")
      }
    },
    openOpera()
    {
      window.open("https://fzztb.fzsggzyjyfwzx.cn/portal/news?classifyCode=A01A01A01")
    }
  },
}
</script>
<style lang="less" scoped>
  ul,li{list-style:none;}
  .home-top{
    background: url(~@/assets/portal/top_backgroud.png);
    height: 100px;
    //display: inline;
    margin:0 auto;
  }
  .home-head{
    background: #118AEC;

  }
  .home-menu{
    height: 40px;background: #118AEC;width: 1200px;margin: 0 auto;
  }

  .home-menu li {
    //display: inline;
    float:left;
    line-height: 40px;
    width:140px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    text-align: center;
  }

  .menuNoSelected{
    font-family: Microsoft YaHei;
    color: #FFFFFF;
    //padding: 10px 35px;
  }

  .menuSelected{
    background-color: #fff;
    border: none;
    //border-radius: 2px 2px 0 0;
    font-family: Microsoft YaHei;
    color: #2a7ee2;
  }
  .floatBtn{
    position: fixed;
    right: 0;
    top: 67%;
    transform: translateY(-50%);
    padding: 10px
  }
  .service {
    width: 76px;
    position: absolute;
    right: 0px;
    top: 0px;
    margin-top: -70px;
    z-index: 99;
    transition: all 0.3s ease 0s;
  }

  .serviceTextDiv {
    width: 140px;
    top: 0px;
    height: 140px;
    right: 80px;
    position: absolute;
    background: #2189e5;
    border-radius: 5px 5px 5px 5px;
    text-align: center;
    visibility: hidden;
  }

  .serviceTextDiv.active {
    visibility: visible;
  }

  .service h3 {
    width: 74px;
    height: 74px;
    margin: 0;
    float: right;
    background: url("~@/assets/portal/在线客服.png") no-repeat center;
    color: #fff;
    font-size: 14px;
    text-align: center;
    border-radius: 8px 0 0 8px;
  }

  .hotline {
    position: absolute;
    right: 0px;
    top: 80px;
    margin-top: -70px;
    z-index: 99;
    transition: all 0.3s ease 0s;
  }

  .hotlineTextDiv {
    display: none;
  }

  .hotlineTextDiv.active {
    width: 156px;
    height: 74px;
    display: block;
    float: left;
    background: #2189e5;
    border-radius: 5px 5px 5px 5px;
    text-align: center;
  }

  .hotline h3 {
    width: 74px;
    height: 74px;
    margin: 0;
    float: right;
    background: url("~@/assets/portal/咨询热线.png") no-repeat center;
    color: #fff;
    font-size: 14px;
    text-align: center;
    border-radius: 8px 0 0 8px;
  }

  .signature{
    position: absolute;
    right: 0px;
    top: 170px;
    margin-top: -80px;
    z-index: 99;
    transition: all 0.3s ease 0s;
  }

  .signature a {
    width: 74px;
    height: 74px;
    margin: 0;
    padding-top: 45px;
    float: right;
    background: url("~@/assets/portal/new统一.png") no-repeat center;
    background-size: cover;
    color: #fff;
    font-size: 14px;
    text-align: center;
    border-radius: 8px 0 0 8px;
  }
  .operamanual{
    position: absolute;
    right: 0px;
    top: 170px;
    margin-top: -80px;
    z-index: 99;
    transition: all 0.3s ease 0s;
  }
  .operamanual a {
    width: 74px;
    height: 74px;
    margin: 0;
    padding-top: 45px;
    float: right;
    background: url("~@/assets/opearmanual.png") no-repeat center;
    background-size: cover;
    color: #fff;
    font-size: 14px;
    text-align: center;
    border-radius: 8px 0 0 8px;
  }

  .sign_font , .sign_font:active ,.sign_font:hover{
    color: #fff;
    text-decoration: none;
    border-bottom: 1px solid #fff;
    font-size: 12px;
    font-weight: bold;
  }
</style>